import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  downloadBox: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    textDecoration: 'none',
    height: theme.spacing(7),

    '&:hover': {
      backgroundColor: theme.palette.neutral.lightest,
    },
  },
  downloadBoxInfoText: {
    color: theme.palette.neutral.dark,
  },
  downloadBoxRightContent: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  downloadBoxRightContentOnlyText: {
    ...theme.typography.h4,
    fontSize: 16,
  },
  downloadBoxMbSize: {
    color: theme.palette.neutral.main,
    marginRight: theme.spacing(2),
  },
  downloadBoxRightTextWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    ...theme.typography.h4,
    fontSize: 16,

    '& svg': {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      margin: theme.spacing(0, 1, 0, 2),
    },
  },
}))

export default useStyles
